export default "__VITE_ASSET__Yi67ny82__"